import React from "react";
import AdminMainLayout from "../AdminMainLayout";
import { Tabs, Row, Col } from "antd";
import SystemThroughput from "../SystemThroughput/SystemThroughput";
import AutomationDetails from "../AutomationDetails/AutomationDetails";
import ModelingCostReport from "../ModelingCostReport/ModelingCostReport"
import ArtistEfficiency from "../ArtistEfficiency/ArtistEfficiency";
import AdminThroughputCharts from "../AdminThroughputCharts/AdminThroughputCharts";
import { withRouter } from "react-router-dom";
import AdminAICharts from "../AdminAICharts/AdminAICharts";

const { TabPane } = Tabs;

const AdminAnalytics = ({ history, location }) => {

  const getActiveTabFromURL = () => {
    try {
      const params = new URLSearchParams(location.search || "");
      const tab = params.get('tab');
      return tab && ["1","2","3","4","5"].includes(tab) ? tab : "1";
    } catch (e) {
      return "1";
    }
  };

  const handleTabChange = (activeKey) => {
    try {
      const params = new URLSearchParams(location.search || "");
      params.set('tab', activeKey);
      const newURL = `${location.pathname}?${params.toString()}`;
      history.replace(newURL);
    } catch (e) {
      console.error(e);
    }
  };

  const defaultTab = getActiveTabFromURL();

  return (
    <>
      <AdminMainLayout selected={"18"} color={true}>
        <Row style={{ marginTop: 30 }} gutter={24}>
          <Col>
            <p className="analytics-txt-heading">
              Analytics Dashboard
            </p>
          </Col>
        </Row>
        <Tabs
          defaultActiveKey={defaultTab}
          onChange={handleTabChange}
          size="small"
          tabBarStyle={{ textAlign: "center" }}
          animated={false}
          tabBarGutter={32}>

          <TabPane tab="AI Self Serve Analytics" key="1">
            <AdminAICharts />
          </TabPane>

          <TabPane tab="Cycle Time and Modelling Throughput" key="2">
            <AdminThroughputCharts />
          </TabPane>

          <TabPane tab="Rendering Throughput" key="3">
            <SystemThroughput />
          </TabPane>

          <TabPane tab="Automation Details" key="4">
            <AutomationDetails />
          </TabPane>

          <TabPane tab="Modeling Cost" key="5">
            <ModelingCostReport />
          </TabPane>

          <TabPane tab="Artist Efficiency" key="6">
            <ArtistEfficiency />
          </TabPane>
        </Tabs>
      </AdminMainLayout>
    </>
  );
};

export default withRouter(AdminAnalytics);